import { snabzhentsAPI } from "./api";

export const getSnabzhentsList = async (params) => {
  try {
    const res = await snabzhentsAPI.getList(params);
    return res;
  } catch (e) {
    console.error('Error fetching snabzhents list:', e);
    return null;
  }
};

export const getSbsProjects = async (search = '', page = 1, limit = 50) => {
  try {
    const res = await snabzhentsAPI.getSbsProjects(search, page, limit);
    return res?.data || [];
  } catch (e) {
    console.error('Error fetching SBS projects:', e);
    return [];
  }
};

export const getRequiredTypes = async () => {
  try {
    const res = await snabzhentsAPI.getRequiredTypes();
    return res?.data || [];
  } catch (e) {
    console.error('Error fetching required types:', e);
    return [];
  }
};
